<template>
  <div id="Lenrefenxi">
    <div class="tr-header">
      <p class="title">冷热分析</p>
    </div>
    <div class="tr-table-container">
      <Checkbox v-model="showNum">显示热号码出现次数</Checkbox>
      <p class="desc">近20期内 热码：出现频繁、活跃的号码；冷码：出现频率低甚至没有出现的号码；温码：介于冷热之间的号码。</p>
      <!-- <Table class="lrtable" :columns="columns" :data="getHotCold" stripe border></Table> -->
      <Table class="lrtable" :columns="columns" :data="dataSource" stripe border></Table>
    </div>
  </div>
</template>
<script>
import columns from "./columns.js";
import statistic from "../../../helpers/statistic";
export default {
  name: "Lenrefenxi",
  data() {
    return {
      columns: [],
      dataSource: [],
      showNum: true
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    getHotCold() {
      return statistic.getHotCold(this.betType, this.dataSource);
    }
  },
  created() {
    this.reset();
  },
  methods: {
    init() {
      // this.reset();
      this.getData();
    },
    reset() {
      this.columns = columns(this);
    },
    async getData() {
      let res = await this.$http.post("/queryGameTypeResultByGameType.do", {
        gameType: this.$route.params.gameType,
        pageSize: 20
      });
      let Hot = await this.$http.post("/queryKcHotReport.do", {
        gameType: this.$route.params.gameType,
        pageSize: 20
      });
      if (Hot.data.returnCode == "0000") {
        this.dataSource = Hot.data.returnList;
        // console.log(this.dataSource, "this.dataSource");

        // if (res.data.returnCode == "0000") {
        //   this.dataSource = res.data.returnList;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    }
  }
};
</script>
<style lang="less" scoped>
#Lenrefenxi {
  .tr-table-container {
    /deep/ .ivu-checkbox-wrapper {
      font-size: 14px;
      color: #333;
    }
    .desc {
      margin: 10px 0 20px;
      font-size: 14px;
      color: #999;
    }
  }
  /deep/ .ivu-table {
    font-size: 14px;
  }
  /deep/.ivu-table-wrapper {
    min-width: 1160px;
  }
  .lrtable {
    /deep/ .hot {
      display: inline-block;
      position: relative;
      margin-right: 8px;
      .badge {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 10px;
        background-color: #f1010a;
        color: #fff;
        border-radius: 50%;
        position: absolute;
        left: 24px;
        top: 2px;
      }
    }
    /deep/ .ball {
      display: inline-block;
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #012537;
      font-weight: 600;
      font-size: 20px;
      margin: 10px 5px;
      background: url("../../../assets/img/bjpknum.png") no-repeat -138px -373px;
    }
    /deep/ .car {
      width: 36px;
      height: 36px;
      display: inline-block;
      margin-right: 5px;
      &.c1 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -246px 0;
      }
      &.c2 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -42px 0;
      }
      &.c3 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -83px 0;
      }
      &.c4 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -123px 0;
      }
      &.c5 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -286px 0;
      }
      &.c6 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -1px 0;
      }
      &.c7 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -205px 0;
      }
      &.c8 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -164px 0;
      }
      &.c9 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -327px 0;
      }
      &.c10 {
        background: url(../../../assets/img/bjpknum.png) no-repeat -368px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Lenrefenxi/index.vue